export default {
  data() {
    return {
      loadingRegions: false,
      resultRegions: [],
      resultCost : 0.0,
      areaResultCost : 0.0
    };
  },
  methods: {
    async changeRegions(id, type) {
      if(id){
        this.loadingRegions = true;
        await this.getCost({'government_id' : id, 'type' : type});
        await this.fetchRegions(id);
        this.resultRegions = this.regions;
        this.resultCost = this.$store.state.externalApi.cost;
        this.loadingRegions = false;
      }
    },
    async changeOffice(id,areaId, type) {
      if(id){
        await this.getCost({'government_id' : id, 'type' : type});
        this.resultCost = this.$store.state.externalApi.cost;
      }
      if(areaId){
        await this.getAreaCost({'area_id' : areaId, 'type' : type});
        this.areaResultCost = this.$store.state.externalApi.area_cost;
      }
    },
    async changeAreas(id, type) {
      if(id){
        await this.getAreaCost({'area_id' : id, 'type' : type});
        this.areaResultCost = this.$store.state.externalApi.area_cost;
      }
    }
  },
};
